import { siteConfig } from "@/config/site";
import { archiveArticles } from "@/features/site/content";

export interface PageMetadata {
  path: string;
  title: string;
  description: string;
  canonical: string;
  indexable: boolean;
}

const definitions = [
  {
    path: "/",
    title: siteConfig.title,
    description: siteConfig.description,
    indexable: true,
  },
  {
    path: "/dashboard",
    title: `داشبورد | ${siteConfig.name}`,
    description: "نمونه‌ی معماری داشبورد React با داده، حالت‌های کامل و Design System سازمانی.",
    indexable: false,
  },
  {
    path: "/style-guide",
    title: `راهنمای رابط | ${siteConfig.name}`,
    description: "نمایش وضعیت‌ها و اجزای پایه‌ی Design System در پروژه.",
    indexable: false,
  },
  {
    path: "/services",
    title: `خدمات قضایی ایرانیان خارج کشور | ${siteConfig.name}`,
    description:
      "ثبت‌نام و احراز هویت ثنا، گواهی عدم سوءپیشینه، ابلاغیه‌های الکترونیکی، مشاوره حقوقی و سایر خدمات قضایی برای ایرانیان خارج از کشور.",
    indexable: true,
  },
  {
    path: "/about",
    title: `درباره ${siteConfig.name} | خدمات ایرانیان خارج از کشور`,
    description:
      "همراه هوشمند، اپراتور دانش‌بنیان خدمات حاکمیتی، دولتی و قضایی برای ایرانیان خارج از کشور؛ با مجوز مرکز آمار و فناوری اطلاعات قوه قضائیه.",
    indexable: true,
  },
  {
    path: "/faq",
    title: `سوالات متداول خدمات قضایی خارج کشور | ${siteConfig.name}`,
    description:
      "پاسخ پرسش‌های رایج درباره ثبت‌نام ثنا، ابلاغیه‌های قضایی، گواهی عدم سوءپیشینه، ممنوع‌الخروجی و مشاوره حقوقی از خارج از کشور.",
    indexable: true,
  },
  {
    path: "/blog",
    title: `مجله ${siteConfig.name} | راهنمای خدمات قضایی ایرانیان خارج کشور`,
    description:
      "راهنماهای مرحله‌به‌مرحله برای ثبت‌نام ثنا، مشاهده ابلاغیه، گواهی‌ها و پیگیری پرونده‌های قضایی از خارج از کشور.",
    indexable: true,
  },
  {
    path: "/contact",
    title: `تماس با ${siteConfig.name} | پشتیبانی بین‌المللی`,
    description:
      "پشتیبانی بین‌المللی همراه هوشمند؛ انتخاب خدمت، ثبت درخواست و پیگیری پرونده از مسیر امن همراه هوشمند.",
    indexable: true,
  },
  {
    path: "/privacy",
    title: `حریم خصوصی | ${siteConfig.name}`,
    description: "صفحه‌ی پایه برای جایگزینی با سیاست حریم خصوصی تاییدشده‌ی پروژه.",
    indexable: true,
  },
  {
    path: "/404",
    title: `صفحه پیدا نشد | ${siteConfig.name}`,
    description: "صفحه‌ی درخواستی پیدا نشد.",
    indexable: false,
  },
] as const;

const articleDefinitions = archiveArticles.map((article) => ({
  path: `/blog/${article.slug}`,
  title: `${article.title} | مجله ${siteConfig.name}`,
  description: article.summary,
  indexable: true,
}));

function normalizePath(pathname: string): string {
  if (pathname === "/") return pathname;
  return pathname.replace(/\/$/, "");
}

export const prerenderRoutes = [
  ...definitions.map((definition) => ({ path: definition.path })),
  ...articleDefinitions.map((definition) => ({ path: definition.path })),
];

export function getPageMetadata(pathname: string): PageMetadata {
  const path = normalizePath(pathname);
  const definition =
    definitions.find((item) => item.path === path) ??
    articleDefinitions.find((item) => item.path === path) ??
    definitions.at(-1);
  if (!definition) throw new Error("Page metadata definitions are empty.");
  const canonicalPath = definition.path === "/404" ? path : definition.path;

  return {
    ...definition,
    path,
    canonical: new URL(canonicalPath, siteConfig.siteUrl).toString(),
  };
}
